import { ReactChildren, ReactChild, FC } from 'react'
import { Flex } from '@chakra-ui/react'
import HorizontalCollapse from 'shared/components/HorizontalCollapse'

type Props = {
  children: ReactChild | ReactChildren
  show: boolean
  width?: number
  fullHeight?: boolean
  bg?: string
}

const RightPanelWrapper: FC<Props> = ({
  children,
  show,
  width = 340,
  fullHeight = true,
  bg = 'whiteAlpha.900'
}) => {
  return (
    <HorizontalCollapse isOpen={show} width={width}>
      <Flex
        h={fullHeight ? 'full' : undefined}
        bg={bg}
        width={`${width}px`}
        overflow='hidden'
        direction={'column'}
      >
        {children}
      </Flex>
    </HorizontalCollapse>
  )
}

export default RightPanelWrapper
